export const SearchSortOptions = {
    Alphabetical: 'alphabetical',
    Created: 'created',
    Default: 'default',
    Draft: 'draft',
    Featured: 'featured',
    HighPrice: 'highPrice',
    InvalidLink: 'invalidLink',
    LowPrice: 'lowPrice',
    New: 'new',
    NewlyCreated: 'newlyCreated',
    Popular: 'popular',
    Trending: 'trending',
    Uncategorised: 'uncategorised',
    Updated: 'updated',
} as const;

export type SearchSortOptions =
    (typeof SearchSortOptions)[keyof typeof SearchSortOptions];
